module.exports = __webpack_public_path__ + "media/img/partners/edumetry-logo-c9629170371896cc5de45f000d210829.png";